import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import useLeaseCompsWithFocusArea from "../../hooks/useLeaseCompsWithFocusArea";
import useLeaseCompsWithGlobalFilters from "../../hooks/useLeaseCompsWithGlobalFilters";
import { useLeaseCompStore } from "../../index";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import LeaseCompsGrid from "../leaseComps/LeaseCompsGrid";

function CompanyDetailsLeaseCompsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const leaseCompStore = useLeaseCompStore();
    const leaseComps = useLeaseCompsWithFocusArea(useLeaseCompsWithGlobalFilters(
        useMemo(() => computed(() => leaseCompStore.leaseComps.filter(lc => lc.pipedriveCompanyId && lc.pipedriveCompanyId.toString() === id)), [id]).get()
    ));

    useEffect(() => setEntityCount(leaseComps.length), [leaseComps]);

    if (!visible)
        return null;

    return (
        <LeaseCompsGrid leaseComps={leaseComps} />
    );
}

export default observer(CompanyDetailsLeaseCompsTab);